import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import AmbGrid from '../../common/AmbGrid';
import ConfirmationDialog from '../../common/ConfirmationDialog';
import { theme, palette } from '../../../theme';
import AmbDropdownTimePicker from 'components/common/AmbDropdownTimePicker';
import times from '../../../helpers/timeOptions';
import AmbInputLabel from 'components/common/AmbInputLabel';

const SegmentRow = styled(AmbGrid)`
  width: 100%;
  margin-bottom: 16px;
  color: ${palette.text.tertiary};
  flex-direction: column;
`;

function EditSegmentsDialogFrame({ segments, handleSave, handleClose, open }) {
  const [disableConfirm, setDisableConfirm] = useState(true);
  const [editedSegments, setEditedSegments] = useState(segments);
  // TODO: implement reason & details
  // const [reason, setReason] = useState('');
  // const [details, setDetails] = useState('');

  const handleDurationChange = (index, value) => {
    const valueToNum = parseInt(value, 10);
    if (isNaN(valueToNum)) {
      return;
    }
    const updated = [...editedSegments];
    updated[index] = {
      ...updated[index],
      seconds: valueToNum,
    };
    setEditedSegments(updated);
    setDisableConfirm(false);
  };

  const formatDisplayValue = (index, selected) => {
    const currSegment = editedSegments[index];
    const label = times[selected] || currSegment.minutesLabel;
    if (!label) return '';

    return label.replace(/(\d+)m/g, '$1 min').replace(/(\d+)h/g, '$1 h');
  };

  const haveSegmentsChanged = () => {
    const isEdited = segments.find((segment, index) => {
      const edited = editedSegments[index];
      return segment.seconds !== edited.seconds;
    });
    return !!isEdited;
  };

  const onClose = ok => {
    if (ok && haveSegmentsChanged()) {
      handleSave(editedSegments);
    } else {
      handleClose();
    }
  };

  // TODO: implemnent AmbSelect dropdown for Reason
  // const ambSelectStyles = {
  //   position: 'relative',
  //   zIndex: 10,
  //   width: 'calc(100% - 32px)',
  //   cursor: 'pointer',
  //   minWidth: 16,
  //   userSelect: 'none',
  //   padding: '6px 32px 7px 0',
  //   MozApearance: 'none',
  //   WebkitAppearance: 'none',
  //   font: 'inherit',
  //   color: '#000',
  //   border: 0,
  //   margin: 0,
  //   display: 'block',
  //   boxSizing: 'content-box',
  //   verticalAlign: 'middle',
  //   WebkitTapHighlightColor: 'transparent',
  //   outline: 'none',
  // };

  return (
    <ConfirmationDialog
      title={
        <div style={{ textAlign: 'left', display: 'flex', fontSize: 20 }}>
          <div style={{ marginLeft: 5 }}>Edit Duration</div>
        </div>
      }
      width="320px"
      onClose={onClose}
      okText="Save"
      cancelText="Cancel"
      open={open}
      cancel
      okButtonStyle={
        disableConfirm
          ? { backgroundColor: palette.grey.light, color: '#94999B' }
          : {
              backgroundColor: palette.primary.main,
              color: palette.secondary.contrastText,
            }
      }
      cancelButtonStyle={{ color: '#335B6C' }}
      disableConfirm={disableConfirm}
    >
      <div>
        {/* Segments Grid */}
        {editedSegments.map((segment, index) => (
          <SegmentRow key={`segment-${index}`}>
            <AmbInputLabel htmlFor="select-currency" style={{ ...theme.mixins.inputLabel }} shrink>
              {`${segment.stateLabel} Duration`}
            </AmbInputLabel>
            <AmbDropdownTimePicker
              times={times}
              placeholder={segment.label}
              onSelect={value => handleDurationChange(index, value)}
              value={segment.seconds}
              disabled={!segment.editable}
              propsStyles={{ width: '100%' }}
              disabledPropsStyles={{
                label: '#858585',
                input: '#858585',
                underline: '#858585',
              }}
              renderValue={value => formatDisplayValue(index, value)}
            />
          </SegmentRow>
        ))}

        {/*TODO: Implement Reason & Details fileds */}

        {/* <div
          style={{
            marginTop: -2,
            border: 0,
            display: 'inline-flex',
            padding: 0,
            position: 'relative',
            minWidth: 0,
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <AmbInputLabel htmlFor="segment-change-reason-select" shrink required style={theme.mixins.inputLabel}>
            Reason
          </AmbInputLabel>
          <AmbSelect
            id="segment-change-reason-select"
            value={reason}
            onChange={e => setReason(e.target.value)}
            options={reasonOptions.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
            style={ambSelectStyles}
            required
          />
        </div> */}

        {/* <div
          style={{
            marginTop: 30,
            display: 'inline-flex',
            width: '100%',
          }}
        >
          <AmbTextField
            id="segment-change-details-input"
            value={details}
            onChange={e => setDetails(e.target.value)}
            multiline
            rows={3}
            label={'Details (optional)'}
            InputLabelProps={{
              style: { ...theme.mixins.inputLabel },
              shrink: true,
            }}
          />
        </div> */}
      </div>
    </ConfirmationDialog>
  );
}

EditSegmentsDialogFrame.propTypes = {
  segments: PropTypes.arrayOf(
    PropTypes.shape({
      state: PropTypes.string,
      duration: PropTypes.string,
      eta: PropTypes.string,
    }),
  ).isRequired,
  handleSave: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default EditSegmentsDialogFrame;
